function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCardsTopActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 169,
    viewBox: "0 0 123 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: -3,
    y: 59.5,
    width: 99,
    height: 130,
    rx: 10,
    transform: "rotate(-30 -3 59.5)",
    fill: "#C2E6D1",
    style: {
      fill: "#C2E6D1",
      fill: "color(display-p3 0.7608 0.9020 0.8196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.7344,
    y: 23.625,
    width: 99,
    height: 130,
    rx: 10,
    transform: "rotate(-15 31.7344 23.625)",
    fill: "#C2E6D1",
    style: {
      fill: "#C2E6D1",
      fill: "color(display-p3 0.7608 0.9020 0.8196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8594 58.2461L104.357 89.961",
    stroke: "#3AB67D",
    style: {
      stroke: "#3AB67D",
      stroke: "color(display-p3 0.2275 0.7137 0.4902)",
      strokeOpacity: 1
    },
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.25 78.3555L115.965 69.8575",
    stroke: "#3AB67D",
    style: {
      stroke: "#3AB67D",
      stroke: "color(display-p3 0.2275 0.7137 0.4902)",
      strokeOpacity: 1
    },
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCardsTopActiveIcon);
export default __webpack_public_path__ + "static/media/addCardsTopActiveIcon.73f936038a205fa8aa79d6fabf00788c.svg";
export { ForwardRef as ReactComponent };